import Cookies from 'js-cookie';

const state = {
    sidebar: {
        opened: Cookies.get('sidebarStatus') ? Boolean(Number(Cookies.get('sidebarStatus'))) : true,
        withoutAnimation: false
    },
    device: 'desktop',
    size: Cookies.get('size') || 'medium'
};
/* eslint-disable no-shadow */
const mutations = {
    toggledSidebar: state => {
        state.sidebar.opened = !state.sidebar.opened;
        state.sidebar.withoutAnimation = false;
        if (state.sidebar.opened) {
            Cookies.set('sidebarStatus', 1, { sameSite: 'strict' });
        } else {
            Cookies.set('sidebarStatus', 0, { sameSite: 'strict' });
        }
    },
    closedSidebar: (state, withoutAnimation) => {
        Cookies.set('sidebarStatus', 0, { sameSite: 'strict' });
        state.sidebar.opened = false;
        state.sidebar.withoutAnimation = withoutAnimation;
    },
    changedDevice: (state, device) => {
        state.device = device;
    },
    settedSize: (state, size) => {
        state.size = size;
        Cookies.set('size', size, { sameSite: 'strict' });
    }
};
/* eslint-enable no-shadow */

const actions = {
    toggleSideBar({ commit }) {
        commit('toggledSidebar');
    },
    closeSideBar({ commit }, { withoutAnimation }) {
        commit('closedSidebar', withoutAnimation);
    },
    toggleDevice({ commit }, device) {
        commit('changedDevice', device);
    },
    setSize({ commit }, size) {
        commit('settedSize', size);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
